import { useNavigate } from "react-router-dom";
import { CreateInstitutionWithAddresses } from "../../types/institution.types";
import { InstitutionsAPI } from "../../APIs/institutions.api";
import { useInstitutions } from "../../context/InstitutionsContext";
import InstitutionsForm from "./institutions-form";
import { useState } from "react";
import { useToast } from "../../components/toast";

export function InstitutionsAdd() {
  const navigate = useNavigate();
  const { handleError, getInstitutions } = useInstitutions();
  const { addToast } = useToast();
  const [newInstitution, setNewInstitution] =
    useState<CreateInstitutionWithAddresses>({
      institution: {
        name: "",
        president: "",
        phone_number: "",
      },
      addresses: [],
    });
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleInstitutionChange = (e: React.ChangeEvent<HTMLElement>) => {
    const { name, value } = e.target as HTMLInputElement;
    setNewInstitution((prevState) => ({
      ...prevState,
      institution: {
        ...prevState.institution,
        [name]: value,
      },
    }));
  };
  const handleAddressChange = (e: React.ChangeEvent<HTMLElement>) => {
    const { name, value } = e.target as HTMLInputElement;
    const index = Number(e.target.id.split("-")[1]);

    setNewInstitution((prev) => ({
      ...prev,
      addresses: prev.addresses.map((address, i) =>
        i === index ? { ...address, [name]: value } : address
      ),
    }));
  };
  const addAddress = () => {
    const newAddress = {
      address_line: "",
      city: "",
      state: "",
      country: "",
    };
    setNewInstitution((prev) => ({
      ...prev,
      addresses: [...prev.addresses, newAddress],
    }));
  };

  const removeAddress = (index: number) => {
    setNewInstitution((prev) => ({
      ...prev,
      addresses: prev.addresses.filter((_, i) => i !== index),
    }));
  };
  const handleCancel = () => {
    navigate("/dashboard/institutions", { replace: true });
  };

  const handleSubmit = async (data: CreateInstitutionWithAddresses) => {
    setIsSubmitting(true);
    try {
      const response = await InstitutionsAPI.postInstitution(data);
      if (response.statusCode === 201) {
        addToast({
          message: `¡Barra pesquera creada!`,
          type: "success",
          location: "bottom-center",
        });
        getInstitutions();
        navigate("/dashboard/institutions", { replace: true });
      } else {
        handleError(response.message);
      }
    } catch (error) {
      handleError(error as string);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <InstitutionsForm
      creatingInstitution={newInstitution}
      handleInstitutionChange={handleInstitutionChange}
      handleAddressChange={handleAddressChange}
      addAddress={addAddress}
      removeAddress={removeAddress}
      handleCancel={handleCancel}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
    />
  );
}
